import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'rebass/styled-components';
import styled from 'styled-components';
import theme from 'styled-theming';
import { StatefulToolTip } from 'react-portal-tooltip';
import { ReactComponent as IconDelete } from '../assets/icon-delete.svg';

const iconDefaultColor = theme('mode', {
  light: (props) => props.theme.colors.warningDark,
  dark: (props) => props.theme.colors.greyMiddle,
});

const iconHoverColor = theme('mode', {
  light: (props) => props.theme.colors.warningDark,
  dark: (props) => props.theme.colors.brightCerulean,
});

const iconDisabledColor = theme('mode', {
  light: (props) => props.theme.colors.warningDark,
  dark: (props) => props.theme.colors.davysGrey,
});

const Icon = styled(IconDelete)`
    stroke-width: 1.5px;
  `;

const DeleteWrapper = styled(Flex)`
    transition: ${(props) => props.theme.animation.quick};
    cursor: pointer;
    color: ${iconDefaultColor};
    &:hover {
      color: ${iconHoverColor};
    }
  `;

const DeleteDisabledWrapper = styled(Flex)`
    transition: ${(props) => props.theme.animation.quick};
    cursor: default;
    color: ${iconDisabledColor};
`;

const tooltipStyle = {
  style: {
    background: '#ccc',
    padding: '14px',
    fontSize: '12px',
    color: '#000',
    transition: 'none',
  },
  arrowStyle: {
    color: '#ccc',
    borderColor: false,
  },
};

function DeleteBucket(props) {
  const { onClick, disabled } = props;

  function handleClick() {
    if (!disabled) {
      onClick();
    }
  }

  const DeleteComponenet = disabled
    ? (
      <DeleteDisabledWrapper
        alignItems="center"
        onClick={handleClick}
        data-testid="delete-button"
      >
        <Icon size={18} />
      </DeleteDisabledWrapper>
    ) : (
      <DeleteWrapper
        alignItems="center"
        onClick={handleClick}
        data-testid="delete-button"
      >
        <Icon size={18} />
      </DeleteWrapper>
    );

  return (
    <StatefulToolTip
      parent={DeleteComponenet}
      position="top"
      arrow="center"
      className="stateful-button"
      tooltipTimeout="100"
      style={tooltipStyle}
    >
      Delete
    </StatefulToolTip>
  );
}

DeleteBucket.defaultProps = {
  onClick: undefined,
  disabled: false,
};

DeleteBucket.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default DeleteBucket;
